"use client";

import React from "react";

export interface InfoBoxProps {
  title: string;
  subtitle?: string;
  items: {
    icon: React.ReactNode;
    label: string;
    value: string;
    description?: string;
  }[];
  footer?: React.ReactNode;
  bgColor?: string;
  borderColor?: string;
}

export function InfoBox({
  title,
  subtitle,
  items,
  footer,
  bgColor = "bg-white",
  borderColor = "border-gray-200"
}: InfoBoxProps) {
  return (
    <section className="py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4">
        <div className={`${bgColor} rounded-3xl border-2 ${borderColor} p-8 md:p-12`}>
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {title}
            </h2>
            {subtitle && (
              <p className="text-xl text-gray-700">
                {subtitle}
              </p>
            )}
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8">
            {items.map((item, index) => (
              <div key={index} className="flex gap-4">
                <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  {item.icon}
                </div>
                <div>
                  <div className="text-sm text-gray-600 mb-1">{item.label}</div>
                  <div className="text-xl font-semibold text-gray-900">{item.value}</div>
                  {item.description && (
                    <div className="text-sm text-gray-600 mt-1">{item.description}</div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {footer && (
            <div className="border-t pt-6">
              {footer}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}